import {useDebugValue} from 'react';

import {useStore} from './useStore';

const storeDataRef = 'experimentData';
const storeKeysRef = 'experimentNames';

const defaultAbacusStore = {
    [storeDataRef]: {},
    [storeKeysRef]: []
};

function useAbacusStore(props) {
    const {
        abacusStore: propsAbacusStore
    } = props;

    const {
        store: abacusStore
    } = useStore({storeDataRef, storeKeysRef}, defaultAbacusStore, propsAbacusStore);

    const result = {
        abacusStore
    };

    useDebugValue(result);

    return result;
}

export {useAbacusStore};
